import { Alert, Button, Grid, Paper, TextField } from "@mui/material"
import { Title } from "components/Common/Title"
import { useFormik } from "formik"
import { useAppDispatch, useAppSelector } from "hooks"
import { useEffect, useState } from "react"
import authService from "services/authService"
import deviceService from "services/deviceService"
import organizationService from "services/organizationService"
import userService from "services/userService"
import { setCurrentOrganization } from "slices/organizationSlice"
import { setCurrentUser } from "slices/usersSlice"
import type { IDeviceAuthenticate } from "types/deviceTypes"
import * as Yup from "yup"

export function DeviceLogin() {
  const dispatch = useAppDispatch()
  const currentUser = useAppSelector((state) => state.users.currentUser)

  const [isLoading, setIsLoading] = useState<boolean>(false)

  const [loginSuccess, setLoginSuccess] = useState<boolean | undefined>(undefined)

  const initialValues: IDeviceAuthenticate = {
    refreshToken: "",
    userCode: "",
  }

  const deviceLoginValidationScheme = Yup.object({
    userCode: Yup.string().required("Please enter user code"),
  })

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: deviceLoginValidationScheme,
    onSubmit: (values) => {
      setIsLoading(true)

      authService
        .getRefreshToken()
        .then((refreshToken) => {
          if (!refreshToken) {
            setIsLoading(false)
            setLoginSuccess(false)
            throw new Error("No refreshtoken found...")
          }

          const deviceLogin: IDeviceAuthenticate = {
            refreshToken: refreshToken,
            userCode: values.userCode,
          }

          deviceService
            .deviceLogin(deviceLogin)
            .then((_resp) => {
              setLoginSuccess(true)
            })
            .catch((err) => {
              console.log(err)
              setIsLoading(false)
              setLoginSuccess(false)
            })
        })
        .catch((err) => {
          console.log(err.message)
          setIsLoading(false)
          setLoginSuccess(false)
        })
    },
  })

  useEffect(() => {
    if (currentUser?.id === undefined) {
      userService
        .getBearerUser()
        .then((user) => {
          dispatch(setCurrentUser(user))

          organizationService
            .getOrganization(user.organizationId)
            .then((organization) => {
              dispatch(setCurrentOrganization(organization))
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [currentUser?.id, dispatch])

  return (
    <Grid container spacing={3}>
      <Grid item xs>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Title>DEVICE LOGIN</Title>
          <form onSubmit={formik.handleSubmit}>
            <Grid item xs>
              <TextField
                autoFocus
                margin="dense"
                id="userCode"
                label="User Code"
                type="text"
                fullWidth
                variant="outlined"
                value={formik.values.userCode}
                onChange={formik.handleChange}
                error={formik.touched.userCode && Boolean(formik.errors.userCode)}
                helperText={formik.touched.userCode && formik.errors.userCode}
              />
            </Grid>
            <Grid item xs marginTop={2}>
              <Button disabled={isLoading} fullWidth variant="contained" type="submit">
                LOGIN
              </Button>
              {loginSuccess !== undefined &&
                (loginSuccess ? (
                  <Alert severity="success">Successful device login!</Alert>
                ) : (
                  <Alert severity="error">No user code found!</Alert>
                ))}
            </Grid>
          </form>
        </Paper>
      </Grid>
    </Grid>
  )
}
